import UI from './utils/UI'

UI({
  component: '.js-fourOhFour'
}, ({ component }) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: '404' })
})
